import { useCallback, useEffect } from "react";
import axios from "../../api/axios";
import { useRecoilState, useSetRecoilState } from "recoil";
import { totalBalanceState, totalDduBalanceState } from "../../atoms/myWallet";
import WalletOutlinedIcon from "@mui/icons-material/WalletOutlined";
import { Button, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LocalPrice from "../../utils/LocalPrice";
import RefreshToken from "../../utils/RefreshToken";
import { useCookies } from "react-cookie";

const WalletInfo = () => {
  const navigate = useNavigate();
  const [, setCookies] = useCookies(["jwt"]);
  const [token] = useCookies(["jwt"]);
  const jwt = token.jwt;

  const [totalBalance, setTotalBalance] = useRecoilState(totalBalanceState);
  const setTotalDduBalance = useSetRecoilState(totalDduBalanceState);

  // const user = JSON.parse(localStorage.getItem("user"));
  // const activeStatus = Number(user?.user?.user_member?.status) === 2;
  const activeStatus = true;

  const walletData = useCallback(() => {
    axios
      .get("wallet")
      .then((response) => {
        setTotalBalance(response.data.data.total_balance);
        // DDU Teminat Bedeli bilgisini al
        if (response.data.data.total_ddu_balance) {
          // total_ddu_balance bir obje ise, tüm veriyi sakla
          const dduBalance = response.data.data.total_ddu_balance;
          if (typeof dduBalance === 'object') {
            setTotalDduBalance(dduBalance);
          } else if (typeof dduBalance === 'number') {
            setTotalDduBalance(dduBalance);
          } else {
            setTotalDduBalance(0);
          }
        } else {
          setTotalDduBalance(0);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          RefreshToken(jwt, navigate, setCookies);
        }
      });
  }, [setTotalBalance, setTotalDduBalance, jwt, navigate, setCookies]);

  const handleNavigate = useCallback(() => {
    if (activeStatus) {
      navigate("/my-wallet");
    }
  }, [activeStatus, navigate]);

  useEffect(() => {
    walletData();
  }, [walletData]);

  return (
    <Tooltip title={"Bakiyem"} placement="bottom">
      <Button
        sx={{
          display: "flex",
          gap: "var(--gap)",
          alignItems: "center",
          border: "1px solid var(--inputBorderColor)",
          padding: "0 10px",
          borderRadius: "var(--inputBorderRadius)",
          height: "30px",
          alignSelf: "center",
          color: "rgba(0, 0, 0, 0.54)",
          position: "relative",
          zIndex: 1201,
          minWidth: "90px",
          ":disabled": {
            opacity: 0.3,
          },
        }}
        disabled={!activeStatus}
        onClick={handleNavigate}
      >
        <WalletOutlinedIcon />
        <span style={{ color: "var(--btnBgBlue)" }}>{LocalPrice(totalBalance)} ₺</span>
      </Button>
    </Tooltip>
  );
};

export default WalletInfo;
